import {api2Endpoint} from 'app/config/apiConfig'
import {postData} from 'app/hooks/api/usePostData'
import {queryDefaults} from 'app/react-query'
import {useQuery} from 'react-query'
import errorNotify from '../api/utils/errorNotify'

export function useGetEntityByIdsV2<T>(
  entity: string,
  ids: string[] | undefined,
  page?: number,
  ppPage?: number,
  errMsg = 'Could not retrieve entity data.',
  withCount?: boolean
) {
  if (!ids) return
  return useQuery({
    queryKey: [`${entity}`, `${ids}${page}`, `${entity}-${ids.toString()}`],
    queryFn: async () => {
      try {
        if (!ids || ids.length === 0) {
          return undefined
        }
        const route = api2Endpoint(`graph/${entity}`)
        const filter: Record<string, any> = {
          id: ids.length === 1 ? ids[0] : ids,
        }
        const select: Record<string, any> = {'*': ''}
        if (entity === 'innovation') {
          select['business'] = {'*': ''}
        }
        if (entity === 'opportunity') {
          //select = {'*': '', office_address: {'*': ''}}
          select['office_address'] = {'*': ''}
        }
        const jsonObj = {
          select: select,
          filter: filter,
          page: page ?? 1,
          per_page: ppPage ?? 10,
          with_count: true,
        }
        const retval = await postData<{
          prev: boolean
          next: boolean
          count: number
          records: T
          query: any
        }>(route, jsonObj, 'post')
        return {
          count: retval?.count ?? 0,
          records: retval.records ?? [],
          next: retval?.next,
          prev: retval?.prev,
        }
      } catch (err) {
        errorNotify(err, errMsg)
      }
    },
    cacheTime: queryDefaults.cacheTime,
    staleTime: queryDefaults.staleTime,
    retry: queryDefaults.retry,
  })
}
